import { render, staticRenderFns } from "./Test.vue?vue&type=template&id=835a064a&scoped=true&"
import script from "./Test.vue?vue&type=script&lang=ts&"
export * from "./Test.vue?vue&type=script&lang=ts&"
import style0 from "./Test.vue?vue&type=style&index=0&id=835a064a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "835a064a",
  null
  
)

export default component.exports